import classNames from 'classnames';

import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import DoneIcon from '@/assets/images/icons/done.svg';

import styles from './styles.module.scss';

interface CheckboxProps {
  id: string,
  name: string,
  value: string | number,
  checked?: boolean,
  label?: string,
  lngKey?: string,
  onClick?: (e: React.MouseEvent<HTMLLabelElement>) => void,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  small?: boolean,
  disabled?: boolean,
  className?: string,
}

const Checkbox: FC<CheckboxProps> = ({
  id,
  name,
  value,
  checked,
  label,
  onClick,
  onChange,
  small,
  className,
  disabled,
  lngKey = '',
}) => {
  const { t } = useTranslation();

  const sm = small ? styles.small : '';
  const db = disabled ? styles.disabled : '';
  const cn = classNames(styles.checkbox, sm, db, className);
  return (
    <div className={cn}>
      <input
        id={id}
        name={name}
        value={value}
        type="checkbox"
        checked={checked}
        data-cy="input"
        onChange={(e) => (disabled ? e.preventDefault() : onChange(e))}
      />
      <label
        htmlFor={id}
        onClick={onClick}
        data-cy="label"
      >
        <DoneIcon className={styles.icon} />
        <span>{label || t(lngKey)}</span>
      </label>
    </div>
  );
};

export default Checkbox;
